import { createSelector } from 'reselect';
import { namespace } from '@common-modules/mediaDetails';
import { Undo } from '../store.models';

const selectStore = (s: { [namespace]: Undo }) => s[namespace];

export const selectHistory = createSelector(selectStore, (s) => s.history);
